import { CloneAuthErrorScreen } from "./clone-auth-error-screen"
import { CloneRedirectScreen } from "./clone-redirect-screen"
import { useCloneLaunchState } from "./use-clone-launch-state"

import { LoadingFallback } from "../router-provider/route-components"

interface CloneLaunchGateProps {
  children: React.ReactNode
}

const getBotHandle = () => `@${import.meta.env.VITE_BOT_USERNAME as string}`

/**
 * A Mini App opened from a clone is signed with the clone's token, which the API rejects by design. Instead of
 * the dashboard with no chats, the admin is sent to the main bot's WebApp, where the same account signs in.
 */
export const CloneLaunchGate: React.FC<CloneLaunchGateProps> = ({ children }) => {
  const state = useCloneLaunchState()

  switch (state.kind) {
    case "pass":
      return children
    case "checking":
      return <LoadingFallback />
    case "redirect":
      return (
        <CloneRedirectScreen
          url={state.url}
          botHandle={getBotHandle()}
        />
      )
    case "auth-error":
      return <CloneAuthErrorScreen botHandle={getBotHandle()} />
  }
}
